module.exports = __webpack_public_path__ + "img/1_D.04872694.png";